<template>
  <a-form ref="formRef" layout="vertical" :model="formState">
    <RequiredField v-model:required="formState.required" />

    <a-form-item label="Texto del campo" name="label" required>
      <a-input v-model:value="formState.label" placeholder="Escribir texto del campo" />
      <p class="info">Escriba aquí su pregunta</p>
    </a-form-item>

    <a-form-item label="Instrucciones">
      <a-input v-model:value="formState.instruction" placeholder="Escribir instrucciones" />
      <p class="info">Añada una pequeña descripción debajo del campo de entrada</p>
    </a-form-item>

    <a-form-item label="Opciones" required>
      <OptionsField v-model:options="formState.options" />
    </a-form-item>

    <a-form-item label="Agregar la opción ”Otro”" class="label__other">
      <a-switch v-model:checked="formState.has_other_option" size="small" />
      <p class="info">El usuario podrá escribir una nueva opción</p>
    </a-form-item>

    <a-form-item label="Límite de selecciones">
      <a-input-number
        v-model:value="formState.selection_limit"
        placeholder="Coloca el número máximo de selecciones"
        style="width: 100%"
        :precision="0"
      />
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import type { FormInstance } from "ant-design-vue";

import { ElementType, FormElementMap, FormStateElementMap } from "@/@types/entities/forms";

import RequiredField from "@/app/entities/components/drawers/forms/settings/fields/RequiredField.vue";
import OptionsField from "@/app/entities/components/drawers/forms/settings/fields/OptionsField.vue";

const props = defineProps<{
  input: FormElementMap[ElementType.MultipleOptions];
}>();

const formRef = ref<FormInstance | undefined>(undefined);

const formState: FormStateElementMap[ElementType.MultipleOptions] = reactive({
  label: props.input.label,
  instruction: props.input.instruction,
  required: props.input.required,
  options: props.input.options,
  has_other_option: props.input.has_other_option,
  selection_limit: props.input.selection_limit,
});

defineExpose({ formRef, formState });
</script>

<style scoped lang="sass">
p
  margin: 0

.ant-form-item-label
  padding: 0

.info
  color: $gray-7

:deep(.label__other .ant-form-item-label)
  padding: 0 !important
</style>
